import React from 'react'
import CreateFlightOfferWorker from './create'
import { Link, withRouter } from 'react-router-dom'
import FlightOfferForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'
import './create.styles.scss'

class CreateFlightOffer extends React.Component {

    constructor(props) {
        super(props)
        this.createFlightOfferWorker = CreateFlightOfferWorker(this)
        this.state = this.createFlightOfferWorker.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.createFlightOfferWorker.isValid() && this.createFlightOfferWorker.createFlightOffer()
    }

    onCancel = () => this.props.history.push('/content/flight-offers')

    render() {
        return (
            <div className="create-flight-offer">
                {
                    this.state.creatingFlightOffer && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/flight-offers">Flight Offers</Link>
                    <div className="header">
                        <h4>Create Flight Offer</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <FlightOfferForm {...this.state} action="Add Flight Offer" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel} />
                </div>
            </div>
        )
    }
}

export default withRouter(CreateFlightOffer)
